var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ItemTableActionBarHeaderMessage',{attrs:{"level":"warn","linkText":"view","message":_vm.unmanagedMessage,"messageHeader":"User Enrolled Devices"}},[(_vm.showViewLink)?_c('ButtonLink',{attrs:{"data-test-id":"UnmanagedDevicesBanner__view","text":"view"},on:{"click":function($event){return _vm.handleClick()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }